var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 32,
    viewBox: "0 0 82 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3 24.5h2.3c2.6 0 3.9-.9 3.8-3 0-2-1.2-2.9-3.6-2.9h-2.5v6Zm0-17.5v5.6h2.3c2 0 3-1 3-3 0-.8-.1-1.4-.7-2-.8-.7-2-.6-2.6-.6h-2ZM68.4.3c3.4 0 5.9.6 7.5 2A7 7 0 0 1 78.4 8a7.7 7.7 0 0 1-3.3 6.8c1.2.5 2.1 1.4 2.9 2.5a7.7 7.7 0 0 1 1.2 4.5c0 2.8-1 5.4-3.2 7.1a13 13 0 0 1-8 2.5c-1.3 0-3 0-5.3-.2a3.3 3.3 0 0 1-3.2-3.3v-24c0-1 .4-1.7 1-2.3.5-.7 1.3-1 2.2-1 1.7-.2 3.7-.2 5.7-.2Z",
    fill: "#8054BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7 24.7h2.5c2.6 0 3.6-1.3 3.7-3 0-1-.3-1.9-1-2.5-.5-.7-1.2-1-2.4-1h-2.8v6.5Zm0-17.7v4.7h3.4c3 0 5 .7 7 2.5a9.3 9.3 0 0 1 2.5 6.9c0 3.2-1 5.7-3 7.5-2 1.8-4.7 2.7-8.5 2.7-2 0-3.6 0-5-.2-.9 0-1.6-.4-2.2-1-.7-.6-1-1.5-1-2.3v-24C35 2 36.5.6 38.2.6h11.5c1.8 0 3.2 1.6 3 3.4 0 1.7-1.3 3.1-3 3.1h-7.9Z",
    fill: "#FF9800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.7 2.9 5.7 1L22 9.1l5.2 1-2.8 4.7 4.6.6-2.6 4.5-6.8-17Z",
    fill: "#231F1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m19.3 18.1-3.2-8.6-3.4 8.6h6.6Zm4.3 11.1-1.8-4.6H10.2l-1.8 4.6a3.1 3.1 0 0 1-3.2 2.2c-.8 0-1.7-.3-2.2-.9a3 3 0 0 1-.7-2c0-.5 0-1 .2-1.3l9.6-24c.8-2.1 2.2-3.2 4.1-3.2 1.9 0 3.3 1 4.1 3.3L30 26.9l.2 1.3c-.1 2-1.6 3.5-3.5 3.3-1.4 0-2.5-.9-3-2.3Z",
    fill: "#FF6170"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon_2.8757d873e130f5b4265f7d0994155061.svg";
export { ForwardRef as ReactComponent };